import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import PaymentMethodModalPage from '../../../containers/masters/PaymentMethod/PaymentMethodModalPage'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class PaymentMethod extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchName: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchPaymentMethodList()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchPaymentMethodList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchPaymentMethodList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleNameChange (searchName) {
    if (this.state.filter.searchName !== searchName) {
      this.setState({ filter: { ...this.state.filter, searchName } })
    }
  }

  searchPaymentMethod () {
    this.props.actions.fetchPaymentMethodList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchName: null
      }
    }, () => { this.searchPaymentMethod() })
  }

  render () {
    const {
      t, paymentMethodList, pagesCount, paymentCount, filter,
      filter: { page },
      actions: { openEditPaymentMethodModal, openAddPaymentMethodModal, fetchPaymentMethodList, deletePaymentMethod, recoverPaymentMethod }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'paymentMethod' })
    const tKey = 'MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t(`${tKey}RECOVER`)}</Tooltip>)
    const hasFilters = (this.state.filter.searchName)
    return (
      <div id='paymentMethodMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new" onClick={() => openAddPaymentMethodModal()}>
              <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.name"
                controlLabel={t(`${tKey}PAYMENT_METHOD_MASTERS.NAME`)}
                placeholder={t(`${tKey}PAYMENT_METHOD_MASTERS.NAME`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchPaymentMethod()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t(`${tKey}RESET_BUTTON`)}
                </Button>
              </div>
            </div>
          </div>
        </div>
        < div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(paymentMethodList.length !== 0) &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('name') }}>
                        {t(`${tKey}PAYMENT_METHOD_MASTERS.NAME`)}
                        <i className={this.getSortIcon('name')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentMethodList && paymentMethodList.map((payment, idx) => {
                      return (
                        <tr key={idx} className={(payment.isDeleted ? 'is-deleted' : '')}>
                          <td>{payment.name}</td>
                          <td className='actions'>
                            {!payment.isDeleted ? (
                              <div>
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => openEditPaymentMethodModal(payment.paymentMethodId)}>
                                    <i className="iDocIcon-edit" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => deletePaymentMethod(payment.paymentMethodId, { ...filter, ...this.state.filter })}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              </div>
                            ) : (
                              <OverlayTrigger placement="left" overlay={recoverTooltip}>
                                <a className='_Btn accent stk o-icn ' onClick={() => recoverPaymentMethod(payment.paymentMethodId, { ...filter, ...this.state.filter })}>
                                  <i className='iDocIcon-undo-back' />
                                </a>
                              </OverlayTrigger>
                            )}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              }
              {(paymentMethodList === null || paymentMethodList === undefined || paymentMethodList.length === 0) &&
                <p className="no_results" >{t(`${tKey}PAYMENT_METHOD_MASTERS.RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={paymentCount}
                    onSelectAction={(value) => fetchPaymentMethodList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <PaymentMethodModalPage />
      </div>
    )
  }
}

export default reduxForm({
  form: 'listPaymentMethod'
})(PaymentMethod)
